import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import source from '../../CHANGELOG.md';
import ReactMarkdown from 'react-markdown';
import { IconButton, Modal, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';
import { env } from '../runtime-environment';
import { useIsMobile } from 'src/utils/media';

export const VersionNumber: React.VFC = () => {
  const mobile = useIsMobile();
  const [open, setOpen] = React.useState(false);
  const [state, setState] = useState('');

  useEffect(() => {
    fetch(source)
      .then((res) => res.text())
      .then((post) => setState(post))
      .catch((error) => {
        console.error(error);
        Sentry.captureException(error);
      });
    return () => {};
  }, []);

  return (
    <>
      <VersionNumberStyle>
        <Typography
          onClick={() => setOpen(true)}
          align="left"
          style={{ color: 'white', fontSize: mobile ? 11 : 'unset' }}
        >
          v{env.VERSION}
        </Typography>
      </VersionNumberStyle>
      <Modal open={open} onClose={() => setOpen(false)}>
        <ModalStyle>
          <IconButton
            onClick={() => setOpen(false)}
            style={{
              position: 'absolute',
              top: '1em',
              right: '1em',
            }}
            size="large"
          >
            <CloseIcon style={{ padding: 0 }} />
          </IconButton>
          <ReactMarkdown>{state}</ReactMarkdown>
        </ModalStyle>
      </Modal>
    </>
  );
};

const VersionNumberStyle = styled.div`
  :hover {
    cursor: pointer;
  }
`;

const ModalStyle = styled(Paper)`
  font-family: Roboto;
  overflow-y: auto;
  left: 8vw;
  top: 5vh;
  width: 84vw;
  height: 90vh;
  position: fixed;
  outline: none;
  padding: 2em;

  & * {
    padding: 0.3em;
    list-style-position: inside;
  }

  h2 {
    padding-top: 1.5em;
  }

  li {
    padding-left: 10px;
  }
`;
